/**
 * ORGANİZATÖR DUYURULARI — İSTEMCİ MUTASYONLARININ İNVALİDASYONU (Story 3).
 *
 * Taslak yazma ve düzenleme etkinliğin duyuru LİSTESİNİ bayatlatır (satır
 * normalize depoya yazılır, liste sırası ve durumu sunucudan tazelenir).
 * "Kendime test gönder" (`announcements/sendTest`) hiçbir listeyi değiştirmez;
 * muafiyeti `invalidation-coverage.guard.spec.ts` içinde gerekçelidir.
 */
/**
 * ALICI TARAFI ANAHTARI (T4a): duyurularını kapattığın kurumlar (Ayarlar ›
 * Bildirimler, tasarım kare 9). Yalnız oturumlu ayar ekranında çizilir.
 */
export const ANNOUNCEMENT_INBOX_CACHE_KEYS = {
    announcementMutes: 'announcementMutes/list',
};
export const ANNOUNCEMENT_INBOX_SERVER_RENDERED = {
    [ANNOUNCEMENT_INBOX_CACHE_KEYS.announcementMutes]: false,
};
export function announcementInvalidation(keys) {
    return {
        /*
         * ALICI TARAFI (T4a): tam metindeki "Bu kurumdan duyuru alma", ayarlardaki
         * "Yeniden aç" ve e-postadaki tek tık ret kapatılan kurumlar listesini
         * değiştirir. Ret sayfası oturumsuzdur; saga listeyi yalnız aynı sekmede
         * daha önce okunmuşsa yeniden ister.
         */
        'announcementInbox/mute': [keys.announcementMutes],
        'announcementInbox/unmute': [keys.announcementMutes],
        'announcementUnsubscribe/apply': [keys.announcementMutes],
        'announcementUnsubscribe/undo': [keys.announcementMutes],
        'announcements/create': [keys.announcementList],
        'announcements/update': [keys.announcementList],
        // Story 4 (T3b): gönder, zamanla ve iptal satırın DURUMUNU ve tarihini değiştirir.
        'announcements/send': [keys.announcementList],
        'announcements/schedule': [keys.announcementList],
        'announcements/cancel': [keys.announcementList],
    };
}
//# sourceMappingURL=invalidation-announcements.js.map